export enum NotificationNumber {
  announcements = "announce_count",
  assets = "asset_count",
  latestEvents = "latest_events_announcement_count",
  priceAlert = "price_alert_total_count",
  systemMessages = "system_manager_count",
  transactions = "transaction_count",
  tradingServices = "trading_service_announcement_count",
  newsResearch = "news_research_announcement_count"
}

export enum NotificationTime {
  announcements = "announce_time",
  assets = "asset_time",
  latestEvents = "latest_events_announcement_time",
  priceAlert = "price_alert_time",
  systemMessages = "system_manager_time",
  transactions = "transaction_time",
  tradingServices = "trading_service_announcement_time",
  newsResearch = "news_research_announcement_time"
}

export enum NotificationTitle {
  announcements = "announce_title",
  assets = "asset_title",
  latestEvents = "latest_events_announcement_title",
  priceAlert = "price_alert_title",
  systemMessages = "system_manager_title",
  transactions = "transaction_title",
  tradingServices = "trading_service_announcement_title",
  newsResearch = "news_research_announcement_title"
}

export interface NotificationData {
  announce_count: number;
  announce_time: number;
  announce_title: string | null;
  asset_count: number;
  asset_time: number;
  asset_title: string | null;
  latest_events_count: number;
  latest_events_time: number;
  latest_events_title: string | null;
  latest_events_announcement_time: number;
  latest_events_announcement_title: string | null;
  latest_events_announcement_count: number;
  price_alert_count: number;
  price_alert_time: number;
  price_alert_title: string | null;
  price_alert_total_count: number;
  system_manager_count: number;
  system_manager_time: number;
  system_manager_title: string | null;
  total_unread_count: number;
  transaction_count: number;
  transaction_time: number;
  transaction_title: string | null;
  trading_service_announcement_count: number;
  trading_service_announcement_time: number;
  trading_service_announcement_title: string | null;
  news_research_announcement_count: number;
  news_research_announcement_time: number;
  news_research_announcement_title: string | null;
}
